var cilDataTransferUp = ["512 512", "<rect width='480' height='32' x='16' y='16' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/><polygon fill='var(--ci-primary-color, currentColor)' points='116.687 212.687 139.313 235.313 232 142.627 232 496 264 496 264 142.627 356.687 235.313 379.313 212.687 248 81.373 116.687 212.687' class='ci-primary'/>"];

export { cilDataTransferUp };
//# sourceMappingURL=cil-data-transfer-up.js.map
